import { moduleName } from '../constants';

const moduleSel = state => state[moduleName] || {};

export const localeSel = state => moduleSel(state).locale || 'en';
